import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { extractError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import Logo from "@/components/Logo";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", password: "", role: "client" });
  const [loading, setLoading] = useState(false);
  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.role === "agency_partner") { navigate("/register-agency"); return; }
    setLoading(true);
    try {
      await register(form);
      toast.success("Compte créé avec succès");
      navigate("/");
    } catch (e) {
      toast.error(extractError(e, "Erreur d'inscription"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0a1e3f] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <div className="text-center mb-8"><Logo variant="light" size="lg" /></div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 mbk-card-shadow" data-testid="register-form">
          <h1 className="font-display text-2xl font-black text-[#0a1e3f]">Créer un compte</h1>
          <p className="text-sm text-gray-500 mt-1">Rejoignez la plateforme.</p>
          <div className="mt-6 space-y-4">
            <div><Label className="text-xs uppercase tracking-widest font-bold text-gray-500">Nom complet</Label><Input data-testid="reg-name" required value={form.full_name} onChange={(e) => upd("full_name", e.target.value)} className="mt-2 h-12" /></div>
            <div><Label className="text-xs uppercase tracking-widest font-bold text-gray-500">Email</Label><Input data-testid="reg-email" type="email" required value={form.email} onChange={(e) => upd("email", e.target.value)} className="mt-2 h-12" /></div>
            <div><Label className="text-xs uppercase tracking-widest font-bold text-gray-500">Téléphone</Label><Input data-testid="reg-phone" value={form.phone} onChange={(e) => upd("phone", e.target.value)} className="mt-2 h-12" /></div>
            <div><Label className="text-xs uppercase tracking-widest font-bold text-gray-500">Mot de passe</Label><Input data-testid="reg-password" type="password" required minLength={6} value={form.password} onChange={(e) => upd("password", e.target.value)} className="mt-2 h-12" /></div>
            <div>
              <Label className="text-xs uppercase tracking-widest font-bold text-gray-500">Vous êtes</Label>
              <RadioGroup value={form.role} onValueChange={(v) => upd("role", v)} className="grid grid-cols-2 gap-3 mt-2">
                <div className="border border-gray-200 rounded-xl p-3 flex items-center gap-2"><RadioGroupItem value="client" id="r-c" data-testid="role-client" /><Label htmlFor="r-c">Client</Label></div>
                <div className="border border-gray-200 rounded-xl p-3 flex items-center gap-2"><RadioGroupItem value="agency_partner" id="r-a" data-testid="role-agency" /><Label htmlFor="r-a">Agence</Label></div>
              </RadioGroup>
              {form.role === "agency_partner" && (
                <p className="text-xs text-[#0e7a3f] mt-2">En cliquant sur "Créer mon compte", vous serez redirigé vers le formulaire dédié aux agences (dossier de partenariat).</p>
              )}
            </div>
          </div>
          <Button data-testid="register-submit" type="submit" disabled={loading} className="mbk-btn-green text-white w-full h-12 mt-6 rounded-full font-semibold">
            {loading ? "Création…" : "Créer mon compte"}
          </Button>
          <div className="text-center mt-6 text-sm text-gray-500">
            Déjà un compte ? <Link to="/login" className="text-[#0a1e3f] font-bold hover:underline">Se connecter</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
